import {axios} from '@js/utilities/axios.js';

export default {
	namespaced: true,
	state: {
		resources: {
			states: [],
			zones: [],
			forgiven_reasons: [],
			todo_types: [],
			cleaner_deregistration_reasons: [],
			lost_reasons: [],
			cancellation_reasons: [],
			client_cancellation_reasons: [],
			service_types: [],
			sources: [],
			booking_sources: [],
      information_session_statuses: []
		},
		app_resources: {
			client_cancellation_reasons: []
		}
	},
	actions: {
		async fetchResources(context, options = {}) {
			const params = {
				'all-states': options?.allStates || null
			}

			return new Promise((resolve, reject) => {
				axios.get('/api/resources', {params}).then(response => {
					context.state.resources = response.data;

					return resolve(response)
				}).catch((err) => {
					toastr.error('An error occurred while fetching the resources.');

					reject(err)
				});
			})
		},
		async fetchAppResources(context) {
			return new Promise((resolve, reject) => {
				axios.get('/api/resources/app').then(response => {
					context.state.app_resources = response.data;

					return resolve(response)
				}).catch((err) => {
					toastr.error('An error occurred while fetching the resources.');

					reject(err)
				});
			})
		}
	},
	mutations: {},
	getters: {
		getResources(state) {
			return state.resources;
		},
		getAppResources(state) {
			return state.app_resources;
		}
	}
}
